import type { HostRibbonState } from './hostRibbonContract';

/**
 * Sends one message of the given type to the WPF shell hosting this view.
 *
 * Outside the shell there is no WebView2 bridge, so publishing is a no-op.
 */
export const postHostMessage = (type: string, state: Record<string, unknown>): void => {
  const webview = window.chrome?.webview;

  if (!webview) {
    return;
  }

  webview.postMessage(JSON.stringify({ type, state }));
};

/**
 * Sends one host ribbon state message to the WPF shell hosting this view.
 */
export const postHostRibbonState = (state: HostRibbonState): void => {
  postHostMessage('hostRibbonState', state);
};
